<template>
  <div class="birthday-message-block-2021">
    <div class="message-form"
         v-ym-report:ANNIVERSARY_2021_MESSAGE_BOARD_SHOW_EXPOSE=""
    >
      <div class="desc">
        写下您的祝福<br>
        分享孩子在少年商学院的成长与收获
        <span>可领取99元《少年领导力》音频课</span>
      </div>
      <input class="user-name"
             type="text"
             v-model="userName"
             placeholder="请输入您的称呼"
             @focus="$emit('focus')"
             @blur="$emit('blur')"
      />
      <textarea class="message-textarea"
                cols="30"
                rows="5"
                v-model="content"
                placeholder="请输入您的留言内容"
                @focus="$emit('focus')"
                @blur="$emit('blur')"
      ></textarea>
      <div class="count">*已有<span>{{ count }}+</span>留言祝福，期待您的参与</div>
      <ym-button class="submit-btn"
                 type="primary"
                 :disabled="submitDisabled"
                 @click.prevent="handleSubmitMessage"
                 v-ym-report:ANNIVERSARY_2021_MESSAGE_WRITING_BUTTON_CLICK=""
      >
        写祝福
      </ym-button>
    </div>
    <div class="message-panel"
         v-ym-report:ANNIVERSARY_2021_MESSAGE_BOARD_EXPOSE=""
    >
      <div class="message-panel-title"><span>精选留言</span></div>
      <div class="birthday-message-block-2021-massage-wall"
           ref="messageWall"
      >
        <div class="birthday-message-block-2021-message-list"
             ref="messageContent"
             :class="[ animationClass ]"
             :style="contentStyle"
             @animationend="handleAnimationEnd"
             @webkitAnimationEnd="handleAnimationEnd"
        >
          <div class="birthday-message-block-2021-message-item"
               v-for="(item, index) in messageList"
               :key="index"
          >
            {{ item.name }}：{{ item && item.content ? item.content : '少年商学院八周年生日快乐🎂' }}
          </div>
        </div>
      </div>
    </div>

    <mobile-verify :message-id="messageId"
                   :show.sync="showMobilePopup"
                   @receiveGift="handleReceiveGiftSuccess"
    />

    <gift-popup :show.sync="showGiftPopup" />
  </div>
</template>

<script>
  import { Button, Toast } from 'ym-mint-ui';
  import MobileVerify from '@/pages/2021/Birthday/components/MobileVerify';
  import GiftPopup from '@/pages/2021/Birthday/components/GiftPopup';
  import {
    getMessageWallInfo,
    createMessage,
    receiveGift,
  } from '@/services/birthday-2021';

  export default {
    name: 'BirthdayMessageBlock2021',
    components: {
      'ym-button': Button,
      MobileVerify,
      GiftPopup,
    },
    props: {
      count: Number,
    },
    data() {
      return {
        messageList: [],
        userName: '',
        content: '',
        messageId: 0,
        showMobilePopup: false,
        showGiftPopup: false,
        requestCount: 0,
        index: 1,
        speed: 5,
        delay: 1,
        wrapHeight: 0,
        firstRound: true,
        duration: 0,
        offsetHeight: 0,
        animationClass: '',
      };
    },
    computed: {
      submitDisabled() {
        return this.userName === '' || this.content === '';
      },
      contentStyle() {
        return {
          animationDelay: `${this.firstRound ? this.delay : 0 }s`,
          animationDuration: `${this.duration}s`,
          animationTimingFunction: 'frames(1000)',
        };
      },
    },
    watch: {
      showMobilePopup(val) {
        if (val) {
          this.$emit('showPopup');
        }
      },
    },
    methods: {
      handleAnimationEnd() {
        this.getMessageList();
        this.handleAnimation();
      },
      async initMessageList() {
        this.messageList = [];
        await this.getMessageList();
        this.handleAnimation();
      },
      handleAnimation() {
        this.$nextTick(() => {
          const { messageWall, messageContent } = this.$refs;
          if (!messageWall || !messageContent) return;
          const wrapHeight = messageWall.getBoundingClientRect().height;
          const offsetHeight = messageContent.getBoundingClientRect().height;
          this.wrapHeight = wrapHeight;
          this.offsetHeight = offsetHeight;
          const { index } = this;
          const animationType = (index % 2) + 1;
          this.animationClass = `birthday-message-block-2021-message-list-play-${animationType}`;
          this.duration = (offsetHeight + wrapHeight) / this.speed;
        });
      },
      async getMessageList() {
        try {
          if (this.requestCount === 4) {
            this.requestCount = 0;
            return;
          }
          const data = await getMessageWallInfo('2021BirthdayMessage');
          this.messageList.push(...(data.list));
          this.requestCount += 1;
          this.getMessageList();
        } catch (e) {
          console.log('e', e);
          this.requestCount = 0;
        }
      },
      async handleSubmitMessage() {
        if (this.userName === '' || this.content === '') return;
        if (this.userName.length < 2) {
          Toast('称呼长度至少要2个字');
          return;
        }
        if (this.content.length < 8) {
          Toast('留言内容至少要8个字');
          return;
        }
        const data = await createMessage(this.userName, this.content, '2021BirthdayMessage');
        if (data.render.isReceive) {
          Toast('感谢您的留言祝福');
          return;
        }
        if (!data.render.needMobile) {
          await this.handleReceiveGift({
            messageId: data.messageId,
            type: '2021BirthdayMessage',
          });
          return;
        }
        this.showMobilePopup = true;
        this.messageId = data.messageId;
      },
      async handleReceiveGift(params) {
        await receiveGift(params);
        this.handleReceiveGiftSuccess();
      },
      handleReceiveGiftSuccess() {
        this.showGiftPopup = true;
      },
    },
    created() {
      this.initMessageList();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .message-form {
    position: relative;
    padding-top: 38px;
    padding-bottom: 50px;
    width: 694px;
    background: @color-white;
    border-radius: 10px;
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .desc {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
      color: #666;
      font-size: 32px;
      line-height: 46px;
      text-align: center;
      span {
        color: #f64c57;
        font-size: 36px;
        font-weight: bold;
      }
    }
    .user-name {
      outline: none;
      width: 636px;
      height: 74px;
      border: 1px solid #36b7b0;
      border-radius: 5px;
      text-align: center;
      -webkit-appearance: none;
      box-sizing: border-box;
      font-size: 26px;
    }
    .message-textarea {
      outline: none;
      margin: @size-small 0;
      padding: 20px;
      width: 636px;
      height: 356px;
      box-sizing: border-box;
      border-radius: 5px;
      border: 1px solid #36b7b0;
      resize: none;
      font-size: 26px;
      line-height: 1.5;
    }
    .count {
      color: #666;
      font-size: 28px;
      text-align: center;
      span {
        color: #ff3542;
      }
      margin: 28px 0 40px;
    }
    .submit-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 280px;
      height: 58px;
      color: #fff;
      font-size: 28px;
      background: linear-gradient(0deg, #F64854 0%, #F75C65 100%);
      border-radius: 15px;
    }
    &:before {
      content: '';
      position: absolute;
      left: 23px;
      bottom: -30px;
      z-index: 9;
      width: 15px;
      height: 55px;
      border-radius: 4px;
      background-color: #1f90a8;
    }
    &:after {
      content: '';
      position: absolute;
      right: 23px;
      bottom: -30px;
      z-index: 9;
      width: 15px;
      height: 55px;
      border-radius: 4px;
      background-color: #1f90a8;
    }
  }

  .message-panel {
    width: 694px;
    height: 460px;
    margin-left: 30px;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #fff8d8;
    margin-top: 10px;
    &-title {
      border-top: 30px solid #ffee9e;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      width: 200px;
      margin-left: 200px;
      text-align: center;
      span {
        position: relative;
        top: -30px;
        color: #f64e59;
        font-size: 32px;
        font-weight: bold;
        letter-spacing: 4px;
      }
    }
  }

  .birthday-message-block-2021 {
    &-massage-wall {
      box-sizing: border-box;
      width: 636px;
      height: 356px;
      overflow: hidden;
      margin: 20px auto;
    }
    &-message-list {
      box-sizing: border-box;
      width: 560px;
      margin: 0 auto;
      z-index: @z-index-medium;
      &-play-1 {
        animation: count-down-bar-play-1 linear both;
      }
      &-play-2 {
        animation: count-down-bar-play-1 steps(80000) both;
      }
    }
    &-message-item {
      width: 560px;
      margin-bottom: @size-extra-medium;
      box-sizing: border-box;
      font-size: @font-size-base;
      color: @color-text-light;
      line-height: 1.7;
    }
  }

  @keyframes count-down-bar-play-1 {
    to {
      transform: translate3d(0, -100%, 0);
    }
  }

  @keyframes count-down-bar-play-2 {
    to {
      transform: translate3d(0, -100%, 0);
    }
  }
</style>
